import { CommentsStore } from "../Comments/CommentsStore";
import "./DeliveryInfoElement.less";
import { FleetLoggerStore } from "../FleetLogger";

export class DeliveryInfoElement extends HTMLElement {
    static tag = "delivery-info";

    connectedCallback() {
        this.insertAdjacentHTML("afterbegin", this.view());
        this.addEventListener("pointerdown", this.onPointerDown, { passive: true });

    }

    private view = () => ` 
        <mark-loaded>Mark Loaded</mark-loaded>
        <mark-unloaded>Mark Unloaded</mark-unloaded>
    `

    private _startX: number;
    private _pointerId: number;

    private onPointerDown = (event: PointerEvent) => {
        this._startX = event.clientX;
        this._pointerId = event.pointerId;
        this.setPointerCapture(event.pointerId);
        this.addEventListener("pointermove", this.onPointerMove, { passive: true });
        this.addEventListener("pointerup", this.onPointerUp, { passive: true });
    }

    private _triggerMarkLoaded = false;
    private _triggerMarkUnloaded = false;

    private onPointerMove = (event: PointerEvent) => {
        let diff = event.clientX - this._startX;

        if (diff < -100)
            diff = -100;
        if (diff > 100)
            diff = 100;


        if (Math.abs(diff) > 1)
            this.toggleAttribute("sliding", true);

        diff = Math.max(-100, diff);

        if (diff > 90)
            this._triggerMarkLoaded = true;
        else
            this._triggerMarkLoaded = false;

        if (diff < -90) 
            this._triggerMarkUnloaded = true;
        else
            this._triggerMarkUnloaded = false
        
        
        this.style.setProperty("--slidy-width", `${Math.round(diff)}px`);
    }

    private getDeliveryType() : "Invoice" | "Return" { 
        if (this.getAttribute("delivery-type") === "Invoice")
            return "Invoice";
        else if (this.getAttribute("delivery-type") === "Return")
            return "Return";
        else
            throw new Error(`Invalid delivery type: ${this.getAttribute("delivery-type")}`);
    }

    private getDeliveryIdentifier() { 
        return {
            type: this.getDeliveryType(),
            invoiceNo: this.getAttribute("invoice-id"),
            orderNo: this.getAttribute("order-id"),
        };
    }

    private onPointerUp = async (event: PointerEvent) => {
        if (this._triggerMarkLoaded) {
            this._triggerMarkLoaded = false;
            this.toggleAttribute("busy", true);
            try {
                await CommentsStore.instance.addComment(this.getDeliveryIdentifier(),
                    `Loaded into van by ${FleetLoggerStore.instance.deviceDetails.initials} at ${new Date().toLocaleTimeString()}`);
                
                this.setAttribute("status", "ongoing");
            } finally { 
                this.removeAttribute("busy");
            }
        }

        if (this._triggerMarkUnloaded) {
            this._triggerMarkUnloaded = false;
            this.toggleAttribute("busy", true);
            try {
                await CommentsStore.instance.addComment(this.getDeliveryIdentifier(),
                    `Unloaded from van by ${FleetLoggerStore.instance.deviceDetails.initials} at ${new Date().toLocaleTimeString()}`);
                
                this.setAttribute("status", "unloaded");
            } finally { 
                this.removeAttribute("busy");
            }
        }

        this.style.setProperty("--slidy-width", "0px");

        this.removeEventListener("pointermove", this.onPointerMove);
        this.removeEventListener("pointerup", this.onPointerUp);

        try { 
            this.releasePointerCapture(this._pointerId);
        } catch (error) {
            console.log("Unable to release pointer capture", error);
        }
        
        setTimeout(() => {
            this.removeAttribute("sliding");
        });
    }
}

customElements.define(DeliveryInfoElement.tag, DeliveryInfoElement);